import React from 'react'
import {base} from 'lib/styleguide/base.scss'
import styles from './Popover.scss'
import {Overlay} from 'react-overlays'
import cx from 'classnames'

export class Popover extends React.PureComponent {
  static defaultProps = {
    insideMargin: true,
    containerPadding: 5
  }

  render () {
    const {
      target,
      container,
      placement,
      onRequestClose,
      insideMargin,
      legacy,
      children,
      containerPadding,
      ...props} = this.props
    return (
      <Overlay show
        rootClose
        onHide={onRequestClose}
        placement={placement}
        insideMargin={insideMargin}
        legacy={legacy}
        container={container}
        target={target}
        containerPadding={containerPadding}>
        <PopoverContents placement={placement} {...props}>
          {children}
        </PopoverContents>
      </Overlay>
    )
  }
}

const OFFSETS = {
  top: {top: -11, left: 0},
  right: {top: 0, left: 11},
  bottom: {top: 11, left: 0},
  left: {top: 0, left: -11}
}

const PopoverContents = ({style, maxWidth, placement, children, noPadding, noArrow, arrowOffsetLeft, arrowOffsetTop, ...props}) => {
  const offset = OFFSETS[placement]
  const left = style.left + offset.left
  const top = style.top + offset.top

  const cn = cx(
    base,
    styles.Popover,
    styles['placement-' + placement],
    noPadding && styles.noPadding
  )
  return (
    <div style={{left, top, maxWidth}} className={cn}>
      {!noArrow && <div className={styles.arrow} style={{left: arrowOffsetLeft, top: arrowOffsetTop}} />}
      {children}
    </div>
  )
}
